/* eslint-disable consistent-return */
import { createAsyncThunk } from '@reduxjs/toolkit';
import create from '../../../services/api';
import API_PATH from '../../../constant/apiPath';
import { updateLoading } from '../loader';

// Define fetchLogout thunk
// const fetchLogout = createAsyncThunk('authentication/logout', async (data: any, { dispatch }) => {
//   const API = create();
//   try {
//     dispatch(updateLoading(true));
//     const response:any = await API.post(API_PATH.USER, data); // Adjust `any` to the correct type if known
//     dispatch(updateLoading(false));
//     localStorage.clear();
//     return response.data;
//   } catch (err) {
//     return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
//   }
// });

// Define handleSendOtp thunk
const handleSendOtp = createAsyncThunk('authentication/send-otp', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.SEND_OTP, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

// Define handleResendOtp thunk
const handleResendOtp = createAsyncThunk('authentication/send-otp', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.RESEND_OTP, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

// Define handleSendOtp thunk
const handleAuthOtp = createAsyncThunk('authentication/send-otp', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.VERIFY_OTP, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

const handleCustomerDetail = createAsyncThunk('authentication/customer-detail', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.CUSTOMER_DETAIL, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

// Define handleSOSUpdate thunk
const handleSOSUpdate = createAsyncThunk('authentication/sos-update', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.LIVELONG, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

export {
  // fetchLogout,
  handleSendOtp,
  handleResendOtp,
  handleAuthOtp,
  handleCustomerDetail,
  handleSOSUpdate
};
